import { render, staticRenderFns } from "./Step5-Content.vue?vue&type=template&id=45d39726&"
import script from "./Step5-Content.vue?vue&type=script&lang=js&"
export * from "./Step5-Content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports